export default "__VITE_ASSET__CyYrF9Su__"